
import AppLayout from './app/Layout'
import AdminLayout from './admin/Layout'

export default {
  App: AppLayout,
  Admin: AdminLayout
}